module.exports = __webpack_public_path__ + "img/home-image2.34c7bc0b.jpg";